const NotificationGrowlComponent = {
    templateUrl: '/ui/notification/growl/growl.tpl.html',
    controller: 'growlController',
    bindings: {
        notification: '<',
        closeNotification: '&'
    }
};

angular.module('umCore')
    .component('uiNotificationGrowl', NotificationGrowlComponent);
